module.exports = __webpack_public_path__ + "static/bank-xingye.6de6e594.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/bank-xingye.png
// module id = 977
// module chunks = 2